import {COLORS, SCREEN_ESM} from 'shared/consts';
import {toEm, toRem} from 'shared/helpers';
import styled from 'styled-components';

type CreateApiaryModalWrapperProps = {
  $minWidth?: number;
};
export const CreateApiaryModalWrapper = styled.form<CreateApiaryModalWrapperProps>`
  @media (width >= ${toEm(SCREEN_ESM)}) {
    min-width: ${(props) => toRem(props.$minWidth || 480)};
  }

  @media (width < ${toEm(SCREEN_ESM)}) {
    width: 100vw;
    height: 100dvh;
    display: flex;
    flex-direction: column;
  }
`;

export const CreateApiaryModalHead = styled.div`
  padding: ${toRem(16)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${toRem(8)};

  @media (width < ${toEm(SCREEN_ESM)}) {
    padding: ${toRem(14)} ${toRem(16)};
  }
`;

export const CreateApiaryModalTitle = styled.h2`
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};

  @media (width < ${toEm(SCREEN_ESM)}) {
    font-size: ${toRem(16)};
  }
`;

export const CreateApiaryModalBody = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};

  @media (width < ${toEm(SCREEN_ESM)}) {
    flex: 1 1 auto;
  }

  .input:has(+ .input) {
    margin-bottom: ${toRem(12)};
  }

  .create-apiary-minimap {
    min-height: ${toRem(240)};
    border-radius: ${toRem(8)};
    cursor: pointer;
    transition: opacity 0.3s ease 0s;
    opacity: 0.7;

    @media (any-hover: hover) {
      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const CreateApiaryModalFooter = styled.div`
  padding: ${toRem(16)};
  display: grid;
  gap: ${toRem(12)};

  @media (width >= ${toEm(SCREEN_ESM)}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (width < ${toEm(SCREEN_ESM)}) {
    margin-top: auto;
  }
`;

export const CreateApiaryMapModalBody = styled.div`
  min-height: ${toRem(354)};
  &:last-child {
    padding-bottom: ${toRem(16)};
  }

  .ymaps3x0--map {
    min-height: ${toRem(354)};
  }

  .create-apiary-map {
    min-height: ${toRem(350)};
    border-radius: ${toRem(8)};
  }

  @media (width >= ${toEm(SCREEN_ESM)}) {
    padding: 0 ${toRem(16)};
  }

  @media (width < ${toEm(SCREEN_ESM)}) {
    flex: 1 1 auto;
  }
`;

export const CreateApiaryMapModalFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  display: grid;
  gap: ${toRem(4)} ${toRem(12)};
  line-height: ${24 / 16};

  @media (width >= ${toEm(SCREEN_ESM)}) {
    grid-template-columns: auto ${toRem(120)};
    .button {
      grid-row: 1 / span 2;
      grid-column-start: 2;
    }
  }

  @media (width < ${toEm(SCREEN_ESM)}) {
    margin-top: auto;
  }

  p {
    display: flex;
    align-items: flex-start;
    gap: ${toRem(4)};
    font-size: ${toRem(14)};

    span {
      &:first-child {
        color: ${COLORS.FG.MUTED};
      }
    }
  }
`;

export const CreateApiaryMapModalMarker = styled.div`
  --width: ${toRem(35)};
  --height: ${toRem(40)};

  margin-top: calc(var(--height) / -2);
  margin-left: calc(var(--width) / -2);
`;
